<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
        <main class="rTSCustomPaddingCss adduserContainer" role="main">
                <div class="pageContentWrapper">
                    <div class="pageHeading">
                        <div class="row">
                            <div class="col-6">
                                <div class="headerName">
                                    <h3>Interventions</h3>
                                    <app-breadcrumb></app-breadcrumb>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="userDashContainer">
                        <div class="">
                        <div class="row ">
                            <div class="col-12">
                            <div class="headerName">
                                <header class="swot-heading">Select User</header>
                            </div>
                            </div>
                        </div>
                        <div class="row userDropDownContainer">
                            <div class="col-sm-3">
                            <div class="scoreCompStyle" id="adduserPopContainer" *ngIf="userList && userList?.length >0">
                                <div class="cusPad">
                                <select class="form-control" [(ngModel)]="selectedCombinedId" placeholder="Select a User" >
                                    <option value="Select User">Select User</option>
                                    <ng-container *ngFor="let user of userList; let i = index;">
                                    <option value="{{user.userId}}_{{user.nextPosition}}_{{user.towerId}}">{{user.userName}}</option>
                                    </ng-container>
                                </select>
                                </div>
                            </div>
                            </div>
                            <div class="col-sm-9 addUserButton text-right">
                                <button type="button" class="btn hvr-bounce-to-top" (click)="loadUserData('fun');funClick()">Functional Competencies
                                </button>
                                <button type="button" class="btn hvr-bounce-to-top mr10" (click)="loadUserData('beh');behClick()">Behavioral Competencies
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    
            
                    <div class="userRcWidthRow">
                       
            
                        <h2 class="mt-1 mb-1" *ngIf="resourceSkillsData?.length >0 && funClicked">Functional Competencies</h2>
                        <!-- <ng-container *ngFor="let oneSkillData of skillData; let j = index;"> -->
                            <ng-container *ngFor="let oneSkillData of commonInterventionData; let j = index;">
                        <ng-container *ngFor="let resourceHistory of resourceSkillsData; let i = index;">

                        <table #tableCanvas *ngIf="resourceSkillsData?.length >0 && oneSkillData.positionId == selectedPositionId && funClicked"
                            class="tableFixHead table table-striped lh-23 rsTable userRcCustomTable customizeRtsScrollBar">
                            <thead>
                                <tr>
                                    
                                    <th>{{oneSkillData.skillName}}</th>
                                    <th>Action</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                
                                        <tr *ngIf="resourceHistory.userId == selectedUserId">
                                         
                                            <td style="width:96%">
                                                <div>
                                                  
                                                    <canvas *ngIf="resourceSkillsData?.length >0" id="skillChar_{{j}}" height="30"
                                                        width="150"></canvas>
                                                </div>
                                            </td>
                                            <td class="addUserButtons">
                                                <div>
                                                    
                                                    <button class="btn buttonClass form-group" title="Intervention"
                                                        data-toggle="modal" data-target="#intervention"
                                                        (click)="getUserInterventions(resourceHistory.userId); onEditSubmit(resourceHistory, 'f_' + oneSkillData.skillId); getInterventionListClick(oneSkillData.skillId, j)">
                                                        <!-- <img src="assets/intervention.png" /> -->
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                 
                                                </div>
                                            </td>
                                        </tr>
            
                            </tbody>
                        </table>
                        </ng-container>
                        </ng-container>
            
            
                        <h2 class="mt-1 mb-1 mt-section" *ngIf="resourceBehSkillsData?.length >0 && behClicked">Behavioral Competencies</h2>
                        <!-- <ng-container *ngFor="let oneSkillData of skillBehData; let j = index;"> -->
                        <ng-container *ngFor="let oneSkillData of commonInterventionData; let j = index;">
                        <ng-container *ngFor="let resourceHistory of resourceBehSkillsData; let i = index;">
                        <table #tableCanvas *ngIf="resourceBehSkillsData?.length >0 && oneSkillData.positionId == selectedPositionId && behClicked" 
                            class="tableFixHead table table-striped lh-23 rsTable userRcCustomTable customizeRtsScrollBar">
                            <thead>
                                <tr>
                                    
                                    <th>{{oneSkillData.skillName}}</th>
                                    <th>Action</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                
                                        <tr *ngIf="resourceHistory.userId == selectedUserId">
                                         
                                            <td style="width:96%">
                                                <div>
                                                    <canvas *ngIf="resourceBehSkillsData?.length >0" id="skillChar_b_{{j}}" height="30"
                                                        width="150"></canvas>
                                                </div>
                                            </td>
                                            <td class="addUserButtons">
                                                <div>
                                                    <button class="btn buttonClass form-group" title="Intervention"
                                                        data-toggle="modal" data-target="#intervention"
                                                        (click)="getUserInterventions(resourceHistory.userId); onEditSubmit(resourceHistory, 'b_' + oneSkillData.skillId); getInterventionListClick(oneSkillData.skillId, j)">
                                                        <!-- <img src="assets/intervention.png" /> -->
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                  
                                                </div>
                                            </td>
                                        </tr>
            
                            </tbody>
                        </table>
                        </ng-container>
                        </ng-container>
            
                    </div>
                </div>

             

                <div class="stepSectionWrapper" *ngIf="selectedUserId == 'Select User'">
                    <div class="stepSection">
                        <div class="starTop">
                            <!-- <div class="fullWidth">
                                <div class="circleWrapper"> <div><i class="fa fa-user"></i></div> <span>User</span> </div>
                            </div> -->
                            <div class="circleWrapper"> <div><i class="fa fa-user"></i></div> <span>User</span> </div>
                            <div class="circleWrapper"> <div><i class="fa fa-user-cog"></i></div> <span>Behavior Skill</span> </div>
                            <div class="circleWrapper"> <div><i class="fa fa-tasks"></i></div> <span>Functional Skill</span> </div>
                        </div>
                        <div class="step-1">
                        <p>Select a user from above drop down.</p>
                        </div>
                      
                    </div>
                </div>
            
                <!--Add User skill Update Modal Box-->
                <div *ngIf="showHideModel" class="modal fade modelClass" id="updateUserSkills" tabindex="-1" role="dialog"
                    aria-labelledby="updateUserSkills" aria-hidden="true">
                    <div class="modal-dialog  modal-dialog-centered" role="document">
                        <form [formGroup]="updateUserSkillForm">
                            <input type="hidden" formControlName="userName" [(ngModel)]="userName">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">User Skill Update Form</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group row">
                                        <label for="level" class="col-sm-3 col-form-label control-label">Skill Levels</label>
                                        <div class="col-sm-9">
                                            <div class="row">
                                                <div class="col-sm-3" style="margin-bottom: 2px;">
                                                    <label class="form-control" style="width: 80px;">StoryLine</label>
                                                </div>
                                                <div class="col-sm-9">
                                                    <select class="form-control form-control-lg" [(ngModel)]="selectedStoryLine"
                                                        [ngClass]="{ 'is-invalid': submitted && f.selectedStoryLine.errors }"
                                                        placeholder="select competency level" formControlName="selectedStoryLine">
                                                        <option value="3_Beginner">Beginner</option>
                                                        <option value="2_Intermediate">Intermediate</option>
                                                        <option value="1_Expert">Expert</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-3" style="margin-bottom: 2px;">
                                                    <label class="form-control" style="width: 80px;">Lectora</label>
                                                </div>
                                                <div class="col-sm-9">
                                                    <select class="form-control form-control-lg" [(ngModel)]="selectedLectora"
                                                        [ngClass]="{ 'is-invalid': submitted && f.selectedLectora.errors }"
                                                        placeholder="select competency level" formControlName="selectedLectora">
                                                        <option value="3_Beginner">Beginner</option>
                                                        <option value="2_Intermediate">Intermediate</option>
                                                        <option value="1_Expert">Expert</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-3" style="margin-bottom: 2px;">
                                                    <label class="form-control" style="width: 80px;">HTML</label>
                                                </div>
                                                <div class="col-sm-9">
                                                    <select class="form-control form-control-lg" [(ngModel)]="selectedHTML"
                                                        [ngClass]="{ 'is-invalid': submitted && f.selectedHTML.errors }"
                                                        placeholder="select competency level" formControlName="selectedHTML">
                                                        <option value="3_Beginner">Beginner</option>
                                                        <option value="2_Intermediate">Intermediate</option>
                                                        <option value="1_Expert">Expert</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn hvr-bounce-to-top dailogButtonClass" title="Update"
                                            (click)="onUpdateSkills(updateUserSkillForm.value)">
                                            Update Competencies
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            
                <!--Add User Intervention Modal Box-->
                <div *ngIf="showHideModel" class="modal fade modelClass" id="intervention" tabindex="-1" role="dialog"
                    aria-labelledby="intervention" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <form [formGroup]="interventionForm">
                            <input type="hidden" formControlName="userName" [(ngModel)]="userName">
            
                            <div class="modal-content modalContent">
                                <div class="modal-header">
                                    <h5 class="modal-title">User Intervention Form</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                    
                                        <div formArrayName="interventionFieldArray" class="mb20" >
                                            <ng-container *ngFor="let contact of interventionFormGroup.controls; let i = index;">
                                                <div class="" [formGroupName]="i">
                                                    <div class="row">
                                                        <input type="hidden" formControlName="savedInterventionId">
                                                        <div class="col-3">
                                                            <label for="level" class="control-label">Competency</label>
                                                            <select class="form-control form-control-lg"
                                                                [ngClass]="{ 'is-invalid': submitted && f.skillId.errors }"
                                                                placeholder="select competency level" formControlName="skillId" [(ngModel)]="clickedSkillId" [attr.disabled]="true? 'disabled' : null">
                                                                <option value="">Select Competency</option>
                                                                <ng-container *ngFor="let skill of skillData;">
                                                                    <option value="f_{{skill.skillId}}">
                                                                        {{skill.skillName}}</option>
                                                                </ng-container>
                                                                <ng-container *ngFor="let skill of skillBehData;">
                                                                    <option value="b_{{skill.skillId}}">
                                                                        {{skill.skillName}}</option>
                                                                </ng-container>
                                                            </select>
                                                        </div>

                                                        <div class="col-3">
                                                            <label for="level" class="control-label">Current Competency</label>
                                                            <select class="form-control form-control-lg"
                                                                [ngClass]="{ 'is-invalid': submitted && f.actualLevel.errors }"
                                                                placeholder="select competency level" formControlName="actualLevel" [(ngModel)]="curRatingVal" >
                                                                <option value="" >Select Competency Level</option>
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                               
                                                            </select>
                                                        </div>

                                                    </div>

                                                    <div class="row">

                                                        <div class="col-3">
                                                            <label for="level" class="control-label">Intervention</label>
                                                            <select class="form-control form-control-lg"
                                                                [ngClass]="{ 'is-invalid': submitted && f.interventionType.errors }"
                                                                placeholder="select intervention" formControlName="interventionId">
                                                                <option value="">Select Intervention</option>
                                                                <ng-container *ngFor="let intervention of interventionList;">
                                                                    <!-- <option value="{{intervention.internventionId}}">
                                                                        {{intervention.interventionType}}</option> -->
                                                                    <!-- <option value="{{currentSkillIntervention.skillId}}"> -->
                                                                    <option value="{{intervention.id}}">
                                                                        {{intervention.trainingPoint}}
                                                                    </option>
                                                                    
                                                                </ng-container>
                                                            </select>
                                                        </div>
                                                        <div class="col-3">
                                                            <label for="level" class="control-label">Expected Competency</label>
                                                            <select class="form-control form-control-lg"
                                                                [ngClass]="{ 'is-invalid': submitted && f.expectedLevel.errors }"
                                                                placeholder="select competency level" formControlName="expectedLevel">
                                                                <option value="">Select Competency Level</option>
                                                                <ng-container *ngFor="let skillRating of skillRatingData;">
                                                                    <option value="{{skillRating.score}}">
                                                                        {{skillRating.ratingName}}</option>
                                                                </ng-container>
                                                            </select>
                                                        </div>
                                                        <div class="col-3">
                                                            <label for="level" class="control-label">Start Date</label>
                                                            <div class="calendarIcon">
                                                                <div class="input-group">
                                                                    <input class="form-control calenderBorder" type="text"
                                                                        autocomplete="off" placeholder="yyyy-mm-dd" ngbDatepicker
                                                                        #d1="ngbDatepicker" formControlName="interventionStartDate">
                                                                    <div class="input-group-append">
                                                                        <button class="btn hvr-bounce-to-top"
                                                                            (click)="setStartDate(); d1.toggle();" type="button">
                                                                            <img src="assets/calendar-icon.svg" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3">
                                                            <label for="level" class="control-label">End Date</label>
                                                            <div class="calendarIcon endDateClass">
                                                                <div class="input-group">
                                                                    <input autocomplete="off"
                                                                        [ngClass]="{ 'is-invalid': submitted && f.interventionEndDate.errors }"
                                                                        placeholder="yyyy-mm-dd" ngbDatepicker #d2="ngbDatepicker"
                                                                        formControlName="interventionEndDate"
                                                                        class="form-control calenderBorder">
                                                                    <div class="input-group-append">
                                                                        <button class="btn hvr-bounce-to-top"
                                                                            (click)="setEndDate(i); d2.toggle();" type="button">
                                                                            <img src="assets/calendar-icon.svg" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                  
                                                </div>
                                            </ng-container>
                                            <div class="modalFooter">
                                                <!-- <button class="btn btn-primary m-1" type="button" (click)="addFeilds()"> Add Field
                                                </button> -->
                                            </div>
                                        </div>
                                        <div *ngIf="userInterventionList?.length>0">
                                            <table class="table table-fixed interventions_table">
                                                <thead>
                                                    <th>Skill</th>
                                                    <th>Current Competency</th>
                                                    <th>Intervention</th>
                                                    <!-- <th>Resource</th> -->
                                                    
                                                    <th>Expected Competency</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Action</th>
                                                </thead>
                                                <tbody class="text-center">
                                                    <ng-container *ngFor="let intervention of userInterventionList;">
                                                        <tr *ngIf="clickedSkillId == intervention.skillId">
                                                            <td>{{getSkillNameById(intervention.skillId)}}</td>
                                                            <td>{{getSkillName(intervention.actualLevel)}}</td>
                                                            <!-- <td>{{getInterventionName(intervention.interventionId)}}</td> -->
                                                            <td>{{getInterventionNameById(intervention.interventionId)}}</td>
                                                            <!-- <td>{{getUserName(intervention.userId)}}</td> -->
                                                            
                                                            
                                                            <td>{{getSkillName(intervention.expectedLevel)}}</td>
                                                            <td>{{intervention.interventionStartDate | date: 'dd-MMM-yyyy'}}</td>
                                                            <td>{{intervention.interventionEndDate | date: 'dd-MMM-yyyy'}}</td>
                                                            <td><button class="btn form-group hvr-bounce-to-top" title="Edit"
                                                                    data-toggle="modal" data-target="#adduserPopContainer"
                                                                    (click)="editSkill($event, intervention)">
                                                                    <img src="assets/edit.svg" />
                                                                </button></td>
                                                        </tr>
                                                        
                                                    </ng-container>
                                                    <!-- <tr class="no_interventions"><td colspan="6">No interventions have been added for this skill yet.</td></tr> -->
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn hvr-bounce-to-top dailogButtonClass" title="Add Intervention"
                                            (click)="saveUserInterventions(interventionForm.value)">
                                            Add Interventions
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
</div>

<!-- page loadder -->
<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>